<template>
  <div class="todoItemList">
    <TodoItemTemplate :part="part" key="tpl" />
    <TodoItem v-for="todoItem in selectedPartTodoItems" :key="todoItem._id" :todoItem="todoItem" />
    <br />
    <div v-if="hasSimplePermissions('addTodoItem')">
      <input @keyup.enter="addNewTodo" type="text" v-model="newTitle" size="10" :placeholder="$t('Add New')" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import TodoItem from '@/components/projectplan/TodoItem';
import TodoItemTemplate from '@/components/projectplan/TodoItemTemplate';

export default {
  name: 'TodoItemList',
  props: ['part'],
  data: function () {
    return {
      newTitle: '',
      loaded: false,
    };
  },
  methods: {
    ...mapActions(['loadSelectedPartTodoItems', 'addTodoItem']),
    addNewTodo: function () {
      let sort = this.selectedPartTodoItems.length;
      this.addTodoItem({
        projectId: this.part.projectId,
        partId: this.part._id,
        newTodoItemProperties: { sort, title: this.newTitle },
      });
      this.newTitle = '';
    },
  },
  computed: {
    ...mapGetters(['hasSimplePermissions', 'selectedPartTodoItems']),
  },
  filters: {},
  components: {
    TodoItem,
    TodoItemTemplate,
  },
};
</script>

<style scoped>
input {
  padding: 6px 6px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/projectplan/TodoItemList.vue